<template>
  <div v-show="fetchedSetting">
    <div class="auth-wrapper auth-v1 row px-1 px-md-2 px-lg-2">
      <div class="inner-left col-md-3">
        <div class="departments d-flex flex-wrap justify-content-center">
          <div class="department-left">
            <div class="department-item d-flex align-items-center department-item">
              <img
                src="/img/logo/logo-without-label.png"
                alt="#"
              >
              <span class="department-text font-weight-bold"><i class="arrow" />ĐÔNG BẮC</span>
            </div>
            <div class="department-item d-flex align-items-center department-item">
              <img
                src="/img/logo/logo-without-label.png"
                alt="#"
              >
              <span class="department-text font-weight-bold"><i class="arrow" />TÂY BẮC</span>
            </div>
            <div class="department-item d-flex align-items-center department-item">
              <img
                src="/img/logo/logo-without-label.png"
                alt="#"
              >
              <span class="department-text font-weight-bold"><i class="arrow" />MIỀN TRUNG</span>
            </div>
            <div class="department-item d-flex align-items-center department-item">
              <img
                src="/img/logo/logo-without-label.png"
                alt="#"
              >
              <span class="department-text font-weight-bold"><i class="arrow" />TÂY NGUYÊN</span>
            </div>
            <div class="department-item d-flex align-items-center department-item">
              <img
                src="/img/logo/logo-without-label.png"
                alt="#"
              >
              <span class="department-text font-weight-bold"><i class="arrow" />TP.HCM</span>
            </div>
            <div class="department-item d-flex align-items-center department-item">
              <img
                src="/img/logo/logo-without-label.png"
                alt="#"
              >
              <span class="department-text font-weight-bold"><i class="arrow" />ĐB. SÔNG CỬU LONG</span>
            </div>
            <div class="department-item d-flex align-items-center department-item">
              <img
                src="/img/logo/logo-without-label.png"
                alt="#"
              >
              <span class="department-text font-weight-bold"><i class="arrow" />ĐÔNG BẮC</span>
            </div>
          </div>
        </div>
      </div>

      <div class="auth-inner col-md-6 py-2">
        <b-card-title class="mb-1 text-center">
          <!-- {{ $t('auth.login.welcome',{'app_name': $app_name}) }} -->
          {{ $app_name }}
        </b-card-title>
        <!-- Login v1 -->
        <b-card
          class="mb-0"
          body-class="px-1 px-md-2 px-lg-2"
        >
          <b-link class="brand-logo flex-column align-items-center">
            <VOVAT-logo />
            <h2 class="brand-text text-primary ml-1">
              NEWS PORTAL
            </h2>
          </b-link>

          <b-card-text class="mb-2 d-none">
            {{ $t('auth.login.welcome_text') }}
          </b-card-text>

          <!-- form -->
          <validation-observer
            ref="loginForm"
            #default="{ handleSubmit }"
          >
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="handleSubmit(login)"
            >
              <!-- username -->
              <b-form-group
                label-for="username"
                :label="$t('auth.username')"
              >
                <validation-provider
                  #default="{ errors }"
                  name="username"
                  rules="required|min:4|max:150"
                >
                  <b-form-input
                    id="username"
                    v-model="username"
                    name="login-username"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Tên đăng nhập, email hoặc số điện thoại"
                    autofocus
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="password">{{ $t('auth.password') }}</label>
                  <b-link
                    :to="{ name: 'auth-forgot-password' }"
                    tabindex="-1"
                  >
                    <small>{{ $t('auth.forgot_password') }}?</small>
                  </b-link>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="password"
                      v-model="password"
                      :type="passwordFieldType"
                      class="form-control-merge"
                      :state="errors.length > 0 ? false : null"
                      name="login-password"
                      :placeholder="$t('auth.password')"
                    />

                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- captcha -->
              <b-row class="captcha-row">
                <b-col cols>
                  <b-form-group
                    label="Mã xác thực"
                    label-for="login-captcha"
                    class="captcha-group"
                  >
                    <div class="form-control captcha-control p-0">
                      <img
                        :src="captcha_image"
                        class="img-fluid captcha-image"
                      >
                      <span
                        class="btn captcha-refresh"
                        @click="refreshCaptcha"
                      >
                        <feather-icon icon="RefreshCcwIcon" />
                      </span>
                    </div>
                  </b-form-group>
                </b-col>
                <b-col cols>
                  <b-form-group
                    label="Nhập mã xác thực"
                    label-for="login-captcha-code"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="captcha"
                      vid="captcha"
                      rules="required"
                    >
                      <b-form-input
                        id="login-captcha-code"
                        v-model="captcha"
                        :state="errors.length > 0 ? false : null"
                        name="login-captcha"
                        placeholder="Mã xác thực"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- checkbox -->
              <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  {{ $t('auth.remember_me') }}
                </b-form-checkbox>
              </b-form-group>

              <!-- submit button -->
              <b-button
                variant="primary"
                type="submit"
                block
                :disabled="loading"
              >
                {{ $t('auth.sign_in') }}
              </b-button>
            </b-form>
          </validation-observer>
          <!--
        <b-card-text class="text-center mt-2">
          <span>{{ $t('auth.not_yet_account') }}? </span>
          <b-link :to="{name:'auth-register'}">
            <span>{{ $t('auth.creat_account') }}</span>
          </b-link>
        </b-card-text> -->

          <div class="divider my-2">
            <div class="divider-text">
              {{ $t('or') }}
            </div>
          </div>

          <!-- social button -->
          <div class="auth-footer-btn d-flex justify-content-center">
            <b-button
              href="javascript:void(0)"
              variant="facebook"
              @click="oauthLogin('facebook')"
            >
              <feather-icon icon="FacebookIcon" />
            </b-button>
            <b-button
              href="javascript:void(0)"
              variant="google"
              @click="oauthLogin('google')"
            >
              <feather-icon icon="MailIcon" />
            </b-button>
          </div>

          <!-- footer info -->
          <div class="text-copyright text-center mt-1 mb-1">
            © Bản quyền tin tức của Đài TNVN, nghiêm cấm sao chép, phổ biến ra bên ngoài nếu không được cho phép
          </div>
          <p class="organization text-center">
            <span>Đơn vị quản lý:</span>
            <span class="font-weight-bold">{{ settings.organization }}</span>
          </p>
          <p class="support text-center">
            <span>Điện thoại hỗ trợ:</span>
            <span class="font-weight-bold text-primary">{{ settings.phones }}</span>
          </p>
        </b-card>
        <!-- /Login v1 -->

      </div>

      <div class="inner-right col-md-3">
        <div class="departments d-flex flex-wrap justify-content-center">

          <div class="department-right">

            <div class="department-item d-flex align-items-center department-item">
              <img
                src="/img/logo/logo-without-label.png"
                alt="#"
              >
              <span class="department-text font-weight-bold"><i class="arrow" />WASHINGTON</span>
            </div>
            <div class="department-item d-flex align-items-center department-item">
              <img
                src="/img/logo/logo-without-label.png"
                alt="#"
              >
              <span class="department-text font-weight-bold"><i class="arrow" />BEIJING</span>
            </div>
            <div class="department-item d-flex align-items-center department-item">
              <img
                src="/img/logo/logo-without-label.png"
                alt="#"
              >
              <span class="department-text font-weight-bold"><i class="arrow" />PARIS</span>
            </div>
            <div class="department-item d-flex align-items-center department-item">
              <img
                src="/img/logo/logo-without-label.png"
                alt="#"
              >
              <span class="department-text font-weight-bold"><i class="arrow" />VIENTIANE</span>
            </div>
            <div class="department-item d-flex align-items-center department-item">
              <img
                src="/img/logo/logo-without-label.png"
                alt="#"
              >
              <span class="department-text font-weight-bold"><i class="arrow" />TOKYO</span>
            </div>
            <div class="department-item d-flex align-items-center department-item">
              <img
                src="/img/logo/logo-without-label.png"
                alt="#"
              >
              <span class="department-text font-weight-bold"><i class="arrow" />CAIRO</span>
            </div>
            <div class="department-item d-flex align-items-center department-item">
              <img
                src="/img/logo/logo-without-label.png"
                alt="#"
              >
              <span class="department-text font-weight-bold"><i class="arrow" />MOSCOW</span>
            </div>

          </div>
          <div class="department-right">

            <div class="department-item d-flex align-items-center department-item">
              <img
                src="/img/logo/logo-without-label.png"
                alt="#"
              >
              <span class="department-text font-weight-bold"><i class="arrow" />PRAGUE</span>
            </div>
            <div class="department-item d-flex align-items-center department-item">
              <img
                src="/img/logo/logo-without-label.png"
                alt="#"
              >
              <span class="department-text font-weight-bold"><i class="arrow" />BANGKOK</span>
            </div>
            <div class="department-item d-flex align-items-center department-item">
              <img
                src="/img/logo/logo-without-label.png"
                alt="#"
              >
              <span class="department-text font-weight-bold"><i class="arrow" />PHNOM PENH</span>
            </div>
            <div class="department-item d-flex align-items-center department-item">
              <img
                src="/img/logo/logo-without-label.png"
                alt="#"
              >
              <span class="department-text font-weight-bold"><i class="arrow" />NEW DELHI</span>
            </div>
            <div class="department-item d-flex align-items-center department-item">
              <img
                src="/img/logo/logo-without-label.png"
                alt="#"
              >
              <span class="department-text font-weight-bold"><i class="arrow" />SYDNEY</span>
            </div>
            <div class="department-item d-flex align-items-center department-item">
              <img
                src="/img/logo/logo-without-label.png"
                alt="#"
              >
              <span class="department-text font-weight-bold"><i class="arrow" />JAKARTA</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Channel -->
      <div class="channels d-flex align-items-center justify-content-center">
        <div class="channel-item text-center">
          <a
            href="https://vov1.vov.vn/"
            target="_blank"
          >
            <img
              src="/img/logo/vov1.png"
              alt=""
            >
          </a>
        </div>
        <div class="channel-item text-center">
          <a
            href="https://vov2.vov.vn/"
            target="_blank"
          >
            <img
              src="/img/logo/vov2.png"
              alt=""
            >
          </a>
        </div>
        <div class="channel-item text-center">
          <a
            href="https://vov3.vov.gov.vn/"
            target="_blank"
          >
            <img
              src="/img/logo/vov3.png"
              alt=""
            >
          </a>
        </div>
        <div class="channel-item text-center">
          <a
            href="https://vov4.vov.gov.vn/"
            target="_blank"
          >
            <img
              src="/img/logo/vov4.png"
              alt=""
            >
          </a>
        </div>
        <div class="channel-item text-center">
          <a
            href="https://vovworld.vn/"
            target="_blank"
          >
            <img
              src="/img/logo/vov5.png"
              alt=""
            >
          </a>
        </div>
        <div class="channel-item text-center">
          <a
            href="http://vov6.vov.vn/"
            target="_blank"
          >
            <img
              src="/img/logo/vov6.png"
              alt=""
            >
          </a>
        </div>
        <div class="channel-item text-center">
          <a
            href="https://vovgiaothong.vn/"
            target="_blank"
          >
            <img
              src="/img/logo/vovgt.png"
              alt=""
            >
          </a>
        </div>
        <div class="channel-item text-center">
          <a
            href="https://english.vov.vn"
            target="_blank"
          >
            <img
              src="/img/logo/english.png"
              alt=""
            >
          </a>
        </div>
        <div class="channel-item text-center">
          <a
            href="https://truyenhinhdulich.vn/"
            target="_blank"
          >
            <img
              src="/img/logo/television.png"
              alt=""
            >
          </a>
        </div>
        <div class="channel-item text-center">
          <a
            href="https://vov.vn/"
            target="_blank"
          >
            <img
              src="/img/logo/tnvn.jpg"
              alt=""
            >
          </a>
        </div>
        <div class="channel-item text-center">
          <a
            href="https://portal.vtc.gov.vn/kenh/vtc1"
            target="_blank"
          >
            <img
              src="/img/logo/vtc.png"
              alt=""
            >
          </a>
        </div>
        <div class="channel-item text-center">
          <a
            href="https://vtc.vn/"
            target="_blank"
          >
            <img
              src="/img/logo/vtcnews.png"
              alt=""
            >
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VOVATLogo from '@core/layouts/components/Logo.vue'
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCard,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip,
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import { showToast } from '@/@core/utils/utils'
import firebaseAuth from '@/libs/firebaseConfig'
import {
  getAuth, signInWithPopup, FacebookAuthProvider, GoogleAuthProvider,
} from 'firebase/auth';

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCard,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BAlert,
    VOVATLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      remember: '',
      password: '',
      username: '',
      userEmail: '',
      captcha: '',
      captcha_key: '',
      status: false,
      captcha_image:
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=',
      sideImg: require('@/assets/images/pages/login-v2.svg'),

      // validation rules
      required,
      email,
      settings: {
        organization: 'TRUNG TÂM SẢN XUẤT VÀ LƯU TRỮ CHƯƠNG TRÌNH',
        phones: '(024) 3266 9067 - 0915 009 926',
      },
      loading: false,
      fetchedSetting: false,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  beforeMount() {
    this.fetchSetting();
  },
  mounted() {
    this.refreshCaptcha()
  },
  methods: {
    oauthLogin(authType) {
      let provider = new FacebookAuthProvider();
      if (authType === 'google') {
        provider = new GoogleAuthProvider();
      }
      if (authType === 'facebook') {
        provider.addScope('public_profile');
        provider.addScope('email');
      }
      signInWithPopup(firebaseAuth, provider)
        .then((result) => {
          // The signed-in user info.
          const { user } = result;

          // This gives you a Facebook Access Token. You can use it to access the Facebook API.
          let credential = FacebookAuthProvider.credentialFromResult(result);
          if (authType === 'google') {
            credential = GoogleAuthProvider.credentialFromResult(result);
          }
          const { accessToken } = credential;
          this.$store.dispatch('auth/oauthLogin', {
            provider: authType,
            uid: user.uid,
            accessToken,
          }).then((response) => {
            const userData = response.data.data.user
            // userData.avatar = '/img/13-small.d796bffd.png'
            userData.fullName = userData.username

            useJwt.setToken(response.data.data.access_token)
            useJwt.setRefreshToken(response.data.data.access_token)
            useJwt.setUser(userData)
            // console.log(userData.ability);
            this.$ability.update(userData.ability)

            this.$store.commit('auth/UPDATE_STATE', userData)

            // ? This is just for demo purpose. Don't think CASL is role based in this case, we used role in if condition just for ease
            this.$router
              .replace(getHomeRouteForLoggedInUser(userData.role))
              .then(() => {
                showToast(`Chào mừng bạn ${userData.fullName || userData.username}`, {
                  icon: 'CoffeeIcon',
                  variant: 'success',
                  text: `Bạn đã đăng nhập với vai trò ${userData.role}. Giờ bạn hãy tiếp tục khám phá!`,
                })
              })
          })
        })
        .catch((error) => {
          // Handle Errors here.
          const errorCode = error.code;
          const errorMessage = error.message;
          // The email of the user's account used.
          const { email } = error.customData;
          // The AuthCredential type that was used.
          const credential = FacebookAuthProvider.credentialFromError(error);
        });
    },
    login() {
      this.$refs.loginForm.validate().then(success => {
        if (success) {
          this.loading = true
          useJwt
            .login({
              username: this.username,
              password: this.password,
              captcha: this.captcha,
              captcha_key: this.captcha_key,
            })
            .then(response => {
              if (response.status === 200) {
                this.loading = false
                this.refreshCaptcha()
                // console.log('response.data', response.data)

                const userData = response.data.data.user
                // userData.avatar = '/img/13-small.d796bffd.png'
                userData.extras = { eCommerceCartItemsCount: 5 }
                userData.fullName = userData.username

                useJwt.setToken(response.data.data.access_token)
                useJwt.setRefreshToken(response.data.data.access_token)
                useJwt.setUser(userData)
                // console.log(userData.ability);
                this.$ability.update(userData.ability)

                this.$store.commit('auth/UPDATE_STATE', userData)

                // ? This is just for demo purpose. Don't think CASL is role based in this case, we used role in if condition just for ease
                this.$router
                  .replace(getHomeRouteForLoggedInUser(userData.role))
                  .then(() => {
                    showToast(`Chào mừng bạn ${userData.fullName || userData.username}`, {
                      icon: 'CoffeeIcon',
                      variant: 'success',
                      // text: `Bạn đã đăng nhập với vai trò ${userData.role}. Giờ bạn hãy tiếp tục khám phá!`,
                    })
                  })
              } else {
                this.loading = false
                this.refreshCaptcha()
              }
            })
        }
      })
    },
    refreshCaptcha() {
      useJwt
        .refreshCaptcha()
        .then(response => {
          if (response.status === 200) {
            this.captcha_image = response.data.data.img
            this.captcha_key = response.data.data.key
          }
        })
    },
    fetchSetting() {
      this.$store.dispatch('settings/getListByAuthGroup').then((res) => {
        if (res.status === 200) {
          this.$store.commit('app/UPDATE_PAGE_LOADING', false);
          this.settings = res.data.data;
          this.fetchedSetting = true;
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

.channels {
  font-size: 0.9rem;
  font-weight: 500;
  flex-wrap: wrap;
  margin: 0 -10px;
  // margin-top: 20px;
  // padding-top: 20px;
  // border-top: 1px solid #ddd;

  .channel-item {
    padding: 0 5px;
    margin-bottom: 10px;

    a {
      display: block;
      padding: 5px 15px;
      border-radius: 25px;
      background-color: #e1e1e1;
    }
  }

  img {
    max-height: 24px;
  }
}

.departments {
  font-size: 0.8rem;
  font-weight: 500;

  .department-item {
    margin: 10px;
  }

  img {
    margin-right: 5px;
    max-height: 16px;
  }

  .arrow {
    width: 0;
    height: 0;
    border-top: 4px solid transparent;
    border-bottom: 4px solid transparent;
    border-left: 4px solid #0a6eb4;
    display: inline-block;
    margin-right: 3px;
  }
}

.text-copyright {
  font-weight: 500;
  font-size: 0.9rem;
}

.organization {
  font-size: 1.1rem;
  text-transform: uppercase;
  color: #666;

  .support {
    color: #0a6eb4;
  }
}

.brand-logo-v2 img {
  max-width: 120px;
  max-height: 60px;
}

.captcha-row {
  margin-left: -5px;
  margin-right: -5px;

  .col {
    padding-left: 6px;
    padding-right: 6px;
  }

  .captcha-control {
    text-align: center;
  }
}
</style>
